module.exports = __webpack_public_path__ + "img/hr-white-desert-bush-11.aa59961d.png";